module.exports = __webpack_public_path__ + "img/yuyuko saigyouji tiny ghost mistress_sc1.818c5d13.png";